/**
 * Dev-only page for live label preview at /dev/label-preview
 * Calls the print-service /api/print/html-label/preview endpoint
 * to render the REAL label template (htmlLabelGenerator.ts).
 * Remove this file after TBHTE-392 is complete.
 */
import { useEffect, useState, useCallback } from 'react';

const SAMPLE_LABEL_DATA = {
  product_name: 'Pork Spare Rib Pieces',
  product_chinese: '排粒',
  product_sku: 'P HCHN1 h40',
  product_ingredient: 'PORK SPARE RIB',
  lot_number: '74099001',
  box_number: 1,
  barcode_number: '74099001',
  actual_weight: '30.00',
  target_weight: '30',
  weight_unit: 'lbs',
  packed_date: '04/09/2026',
  packed_time: '10:15 AM',
  packed_timestamp: '2026-04-09T10:15:00',
  operator_id: '1234',
  operator_name: 'Test Operator',
  station_number: 1,
  station_name: 'Station 1',
  raw_material_lot: 'RM-001',
  raw_material_type: '',
  production_location: 'H',
  qr_data: 'TEST-QR-DATA',
};

export default function DevLabelPreview() {
  const [imgSrc, setImgSrc] = useState<string>('');
  const [loading, setLoading] = useState(true);

  const fetchPreview = useCallback(async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch('/api/print/html-label/preview', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        },
        body: JSON.stringify({
          label_data: SAMPLE_LABEL_DATA,
          barcode_data: '01467514591201383202004000210932001074099',
          barcode_display_text: '(01)46751459120138(3202)004000(21)093200(10)74099',
        }),
      });
      const blob = await res.blob();
      setImgSrc(URL.createObjectURL(blob));
    } catch (err) {
      console.error('Preview fetch failed:', err);
    }
    setLoading(false);
  }, []);

  useEffect(() => { fetchPreview(); }, [fetchPreview]);

  return (
    <div style={{ padding: 32, background: '#f3f4f6', minHeight: '100vh' }}>
      <h1 style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 16 }}>
        Label Preview (Dev) — TBHTE-392
      </h1>
      <button
        onClick={fetchPreview}
        style={{
          marginBottom: 16, padding: '8px 20px', fontSize: 14,
          background: '#2563eb', color: '#fff', border: 'none',
          borderRadius: 6, cursor: 'pointer',
        }}
      >
        {loading ? 'Loading...' : 'Refresh Preview'}
      </button>
      <div style={{ border: '2px solid #333', display: 'inline-block', background: '#fff' }}>
        {imgSrc && <img src={imgSrc} alt="Label Preview" style={{ display: 'block' }} />}
      </div>
    </div>
  );
}
